const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.borderRadius = "4px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "300px";
    tooltipElement.style.width = "100%";
    tooltipElement.style.height = "auto";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "fixed";
    tooltipElement.style.zIndex = 1400;
    tooltipElement.style.transform = "translate(-50%, 0)";
    tooltipElement.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const patientAnalyticTooltipHandler = (context) => {
  const { chart, tooltip } = context;

  const dataPoint = tooltip.dataPoints?.[0];

  if (!dataPoint) {
    return;
  }

  const {
    label,
    dataIndex,
    dataset: { data, duration, backgroundColor: colors },
  } = dataPoint;

  // Tooltip Element
  const tooltipElement = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const table = tooltipElement.querySelector("table");

    const firstRow = document.createElement("tr");
    const colorElement = document.createElement("td");

    const titleElement = document.createElement("td");
    titleElement.textContent = label;
    titleElement.style.fontSize = "16px";
    titleElement.style.fontFamily = "Roboto";

    const span = document.createElement("span");

    span.style.background = colors;
    span.style.borderWidth = "2px";
    span.style.borderRadius = "50%";
    span.style.marginRight = "5px";
    span.style.width = "10px";
    span.style.height = "10px";
    span.style.display = "block";

    colorElement.appendChild(span);
    firstRow.appendChild(colorElement);
    firstRow.appendChild(titleElement);

    const secondRow = document.createElement("tr");
    const space = document.createElement("td");

    const valueContainer = document.createElement("td");

    const valueElement = document.createElement("span");
    valueElement.textContent = data[dataIndex] ?? 0;
    valueElement.style.fontSize = "14px";
    valueElement.style.fontWeight = "500";

    secondRow.appendChild(space);
    valueContainer.appendChild(valueElement);
    secondRow.appendChild(valueContainer);

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(firstRow);
    table.appendChild(secondRow);

    const durationValue = duration?.[dataIndex];
    if (durationValue) {
      const durationRow = document.createElement("tr");
      const durationSpace = document.createElement("td");
      const durationContainer = document.createElement("td");

      const durationElement = document.createElement("span");
      durationElement.textContent = `Duration: ${durationValue}`;
      durationElement.style.fontSize = "12px";
      durationElement.style.color = "#616161";

      durationRow.appendChild(durationSpace);
      durationContainer.appendChild(durationElement);
      durationRow.appendChild(durationContainer);

      table.appendChild(durationRow);
    }
  }

  const canvasRect = chart.canvas.getBoundingClientRect();

  const halfTooltipWidth = tooltipElement.offsetWidth / 2;
  const clampedCaretX = Math.min(
    Math.max(tooltip.caretX, halfTooltipWidth),
    chart.width - halfTooltipWidth
  );

  // Display, position, and set styles for font
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = canvasRect.left + clampedCaretX + "px";
  tooltipElement.style.top = canvasRect.top + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
